import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

const s = (v) => (v !== null && v !== undefined ? String(v) : "");
const b = (v) => v === true || v === "yes" || v === "true";

/**
 * Updates entity primary + KYC data.
 * POST api/Onboarding/update-entity
 */
export const updateEntityAction = async (_entityId, entityData) => {
  try {
    const now = new Date().toISOString();
    const e = entityData;

    // Build gstList from entity.gstList (already an array of objects)
    const gstList = Array.isArray(e.gstList)
      ? e.gstList.map((g, i) => ({
          id: g.id || i + 1,
          gstNumber: s(g.gstNumber),
          state: s(g.state || g.gstState),
          gstAddress: s(g.gstAddress),
          gstCertificatePath: s(g.gstCertificatePath),
        }))
      : [];

    const payload = {
      // ── Identifiers ──────────────────────────────────────────────────────
      entityPrimaryId: e.entityPrimaryId || e.id || 0,
      kycId: s(e.kycId),

      // ── KYC fields ───────────────────────────────────────────────────────
      tradeName: s(e.tradeName),
      pinCode: s(e.pinCode),
      city: s(e.city),
      state: s(e.state || e.State),
      address: s(e.address),
      natureOfBusiness: s(e.natureOfBusiness),
      contactPersonName: s(e.contactPersonName),
      designation: s(e.contactPersonDesignation || e.designation),
      mobileNumber: s(e.contactPersonMobile || e.mobileNumber),
      entityType: s(e.entityType),

      // ── MSME ─────────────────────────────────────────────────────────────
      isRegisteredUnderMSME: b(e.isMSMERegistered ?? e.isRegisterdUnderMSME),
      msmeRegistrationNumber: s(e.msmeNumber || e.msmeRegistrationNumber),

      // ── Document numbers ─────────────────────────────────────────────────
      panCardNumber: s(e.panCardNumber || e.CompanypanNumber),
      aadharCardNumber: s(e.aadharCardNumber),
      partnershipDeedNumber: s(e.partnershipDeedNumber),
      aadharNumberOfBothPartners: s(e.aadharNumberOfBothPartners),
      certificateOfIncorporationNumber: s(e.certificateOfIncorporationNumber),
      directorPANNumber: s(e.directorPANNumber),
      directorAadharNumber: s(e.directorAadharNumber),
      trustDeedNumber: s(e.trustDeedNumber),
      panOfTrustNumber: s(e.panOfTrustNumber),
      aadharNumberOfTrustee: s(e.aadharNumberOfTrustee),
      panOfTrusteeNumber: s(e.panOfTrusteeNumber),

      // ── GST / Utility ────────────────────────────────────────────────────
      isGSTRegistered: b(e.isGSTRegistered),
      utilityType: s(e.utilityType),
      providerName: s(e.utilityProviderName || e.providerName),
      accountOrConsumerNumber: s(
        e.utilityAccountNumber || e.account_ConsumerNumber,
      ),
      addressOnUtilityBill: s(e.utilityAddress || e.addressOnUtilityBill),

      // ── Bank ─────────────────────────────────────────────────────────────
      provideBankDetails: b(e.hasBankDetails ?? e.provideBankDetails),
      bankName: s(e.bankName),
      accountNumber: s(e.accountNumber),
      ifscCode: s(e.ifscCode),
      accountType: s(e.accountType),
      branchName: s(e.branchName),
      beneficiaryName: s(e.beneficiaryName),
      relationWithBeneficiary: s(e.relationWithBeneficiary),

      // ── Document paths ───────────────────────────────────────────────────
      msmeCertificatePath: s(e.msmeCertificatePath),
      aadharCardPath: s(e.aadharCardPath),
      panCardPath: s(e.panCardPath),
      partnershipDeedPath: s(e.partnershipDeedPath),
      aadharOfBothPartnersPath: s(e.aadharOfBothPartnersPath),
      certificateOfIncorporationPath: s(e.certificateOfIncorporationPath),
      directorPANPath: s(e.directorPANPath),
      utilityBillDocumentPath: s(e.utilityBillDocumentPath),
      passbookOrCancelledChequePath: s(e.passbookOrCancelledChequePath),
      uploadSignedFormPath: s(e.uploadSignedFormPath),

      // ── GST list ─────────────────────────────────────────────────────────
      gstList: b(e.isGSTRegistered) ? gstList : [],

      // ── Uploaded list (empty on update — paths already stored above) ─────
      uploadedList: [],

      // ── Timestamps ───────────────────────────────────────────────────────
      createdBy: s(e.createdBy),
      createdOn: s(e.createdOn) || now,
      modifiedBy: s(e.modifiedBy) || "Admin",
      modifiedOn: now,
      isDocumentUploaded: e.isDocumentUploaded === true ? true : false,

      // ── Primary / entity-level fields ────────────────────────────────────
      parentCode: s(e.parentCode || e.parentId),
      parentName: s(e.parentName),
      entityName: s(e.entityName),
      entityCategory: s(e.entityCategory),
      entityLOBType: s(e.entityLOBType || e.lobType),
      aaDepartmentFunction: s(e.aaDepartmentFunction),
      emailAddress: s(e.emailAddress),
      spoC_EmailAddress: s(e.spocEmailAddress || e.spoC_EmailAddress),
      kyC_URL: s(e.kyC_URL),
      requireKYC: b(e.requireKYC),
    };

    console.log("[UpdateEntity] payload:", payload);

    const response = await apiClient.post(
      ATP_API_URL.UPDATE_FORM_ALL_DATA,
      payload,
    );

    if (response?.status === 200) {
      if (response.data?.success === false) {
        return {
          success: false,
          message: response.data.message || "Failed to update entity",
        };
      }
      return {
        success: true,
        data: response.data,
        message: "Entity updated successfully",
      };
    }

    return { success: false, message: "Failed to update entity" };
  } catch (error) {
    console.error("[UpdateEntity] error:", error);
    return {
      success: false,
      message: error.message || "Failed to update entity",
      error,
    };
  }
};
